import NextLink from "@/components/case-study/common/NextLink";
import About from "@/components/case-study/kyc/About";
import BrandIdentity from "@/components/case-study/kyc/BrandIdentity";
import Detail from "@/components/case-study/kyc/Detail";
import Hero from "@/components/case-study/kyc/Hero";
import Services from "@/components/case-study/kyc/Services";
import StyleGuide from "@/components/case-study/kyc/StyleGuide";
import UIScreens from "@/components/case-study/kyc/UIScreens";
import Layout from "@/components/layout/Layout";

const Kyc = () => (
  <Layout
    description="Discover how we created a Know Your Customer (KYC) app with a collaborative review platform for service providers across different industries. Stay informed and enhance your customer experience.        "
    keywords={"know your customer app, know your customer, kyc app"}
    title="KYC App Design and Development Case Study by ultroNeous Technologies"
  >
    <Hero />
    <About />
    <Services />
    <Detail />
    <BrandIdentity />
    <StyleGuide />
    <UIScreens />
    <NextLink
      nextImg={"/assets/case-study/next-case-study/linx.webp"}
      nextLink={"/portfolio/social-networking-app-case-study"}
      nextTitle={"Next <br/> case Study"}
    />
  </Layout>
);

export default Kyc;
